var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSwap = function SvgSwap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#121619",
    d: "M11.03 15.97a.75.75 0 0 1 0 1.06l-3 3a.75.75 0 0 1-1.06 0l-3-3a.751.751 0 0 1 1.06-1.06l1.72 1.72V4.5a.75.75 0 0 1 1.5 0v13.19l1.72-1.72a.75.75 0 0 1 1.06 0m9-9-3-3a.75.75 0 0 0-1.06 0l-3 3a.75.75 0 0 0 1.06 1.06l1.72-1.72V19.5a.75.75 0 1 0 1.5 0V6.31l1.72 1.72a.75.75 0 1 0 1.06-1.06"
  })));
};
export default SvgSwap;